import React, {Component} from 'react'
import {NavBar,ListView,Toast,Icon} from 'antd-mobile';
import {selfdislist} from '../../../service/homeService';
import {connect} from "react-redux";
import './style.less';
let pageIndex = 1;
let pageSize = 10;
const dataError = require('../../../common/image/wrongData.png');
const noOrder = require('../../../common/image/noOrder.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class AuditInspection extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            OrderListData:[],
            dataSource,
            isLoading: true,
            notDataLoading:0,
        };
    }
    componentDidMount(){
        pageIndex = 1;
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
            }
        };
       this._getOrderList(params);
    }
    _getOrderList(params){
        selfdislist(params).then((res) => {
            if(res.data.code == "0000"){
                if (res.data.data.list.length > 0) {
                    this._setDataSource(res.data.data);
                    // this.setState({data:res.data.data.list})
                }else{
                    this.setState({isLoading: false,notDataLoading:1});
                }
            }else {
                this.setState({notDataLoading:2,isLoading: false});
                Toast.info(res.data.msg,3)
            }
        })
    };
     //数据拼接
     _setDataSource(data) {
        const allData = [...this.state.OrderListData, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            OrderListData: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex,
                },
            };
            this._getOrderList(params);
        }
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={noOrder} />
                        <p>暂无数据</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    
    render() {
        const _renderRow = (i, index, rowID) => (
            <div onClick={()=>this.props.history.push('/auditDetail', i)} key={rowID} className={i.status == 0 ? "list listwsh" : "list listysh"}>
                <div className="top">
                    <span>司机： {i.driverName}</span>
                    {i.status == 0 ? <span className="btn">审核</span> : null}
                </div>
                <div className="top">所属分公司：{i.companyName}</div>
                <div className="top">
                    <span>填写时间：{i.createDate}</span>
                    {[
                        i.status == 1 ? <span className="ysh">已审核</span> : null,
                        i.status == 2 ? <span className="ysh">未识别出时间</span> : null,
                        i.status == 3 ? <span className="ysh">不在有效期内</span> : null,
                        i.status == 4 ? <span className="ysh">审核未通过</span> : null,
                        i.status == 5 ? <span className="ysh">健康码非本人</span> : null,
                    ]},
                </div>
            </div>
        )
        return (
            <div className="wraps">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" 
                    onClick={() => this.props.history.goBack()}></i>
                }
                >
                    自检单审核
                </NavBar>
                <div className="content">
                    {
                        this.state.notDataLoading == 0  ?
                        <ListView
                            ref={el => this.lv = el}
                            dataSource={this.state.dataSource}
                            renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                            renderRow={_renderRow}
                            style={{
                                height: '100%',
                                overflow:'auto'
                            }}
                            onEndReached={this._onEndReached.bind(this)}
                            scrollRenderAheadDistance={300}
                            onEndReachedThreshold={30}
                        />: this.notData()

                    }        
                           
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/AuditInspection/index.js